type FormListItem = Record<string, any>

export function mergeFormListByKey<T extends FormListItem>(
  items: T[],
  originalItems: FormListItem[] | undefined,
  key: string,
): T[]
export function mergeFormListByKey<T extends FormListItem>(
  items: T[] | undefined,
  originalItems: FormListItem[] | undefined,
  key: string,
): T[] | undefined
export function mergeFormListByKey<T extends FormListItem>(
  items: T[] | undefined,
  originalItems: FormListItem[] | undefined,
  key: string,
): T[] | undefined {
  if (!items) {
    return items
  }

  const originalItemMap = new Map(
    (originalItems ?? [])
      .filter(item => item?.[key] !== undefined && item?.[key] !== null)
      .map(item => [item[key], item]),
  )

  return items.map(item => ({
    ...(originalItemMap.get(item?.[key]) ?? {}),
    ...item,
  }))
}

export function mergeFormListByIndex<T extends FormListItem>(
  items: T[],
  originalItems: FormListItem[] | undefined,
): T[]
export function mergeFormListByIndex<T extends FormListItem>(
  items: T[] | undefined,
  originalItems: FormListItem[] | undefined,
): T[] | undefined
export function mergeFormListByIndex<T extends FormListItem>(
  items: T[] | undefined,
  originalItems: FormListItem[] | undefined,
): T[] | undefined {
  if (!items) {
    return items
  }

  return items.map((item, index) => ({
    ...(originalItems?.[index] ?? {}),
    ...item,
  }))
}
